
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"14","fill":"none","viewBox":"0 0 12 14"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","d":"M11.7928 8.2678l-5.24999 5.5c-.14159.1484-.33791.2324-.54297.2324-.20506 0-.40137-.084-.54297-.2324l-5.249997-5.5c-.2851561-.29979-.2744061-.77441.025375-1.06054.296875-.28612.773442-.2754 1.060562.02538l3.95703 4.14586V.750732c0-.414062.33594-.74999958.75-.74999958s.75.33593758.75.74999958V11.3785l3.95706-4.14583c.2861-.30078.7627-.31153 1.0605-.02541.2998.28613.3106.76075.0254 1.06054z"}})])
          )
        }
      }
    